import { FadeUp, Eyebrow } from "./motion";

const CHAPTERS = [
  {
    n: "I",
    title: "Prevention before pain",
    body: "Musculoskeletal disorders are the leading cause of workplace disability worldwide. We build technology that intervenes before the first injury — not after the claim.",
  },
  {
    n: "II",
    title: "Assist, don't replace",
    body: "The human body is remarkable. ErgoAssist amplifies natural movement with tuned springs and hydraulics, keeping the worker in full control of every motion.",
  },
  {
    n: "III",
    title: "Ergonomics as infrastructure",
    body: "Safety shouldn't be a poster on a wall. It should be worn, felt, and engineered into every lift, bend, and shift on the floor.",
  },
  {
    n: "IV",
    title: "Dignity in physical work",
    body: "We exist to enhance quality of life for the people who move the world — protecting bodies today so careers can last for decades.",
  },
];

const Manifesto = () => {
  return (
    <section id="mission" data-testid="mission-section" className="py-24 lg:py-40 bg-[#121212] border-t border-[#27272a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <FadeUp>
          <Eyebrow num="03">Our Mission</Eyebrow>
        </FadeUp>
        <FadeUp delay={0.05}>
          <p className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#f5f5f5] mt-8 max-w-4xl leading-[1.1]">
            To enhance quality of life and improve workplace safety through assistive
            technology that prevents{" "}
            <span className="text-[#ff4500]">musculoskeletal harm before it starts.</span>
          </p>
        </FadeUp>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
          {CHAPTERS.map((c, i) => (
            <FadeUp key={c.n} delay={i * 0.08}>
              <div className="border-l-2 border-[#ff4500] pl-6 lg:pl-8">
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-display text-4xl text-[#27272a] leading-none">{c.n}</span>
                  <span className="font-mono-accent text-[11px] tracking-widest uppercase text-[#71717a]">
                    Chapter
                  </span>
                </div>
                <h3 className="font-display text-2xl lg:text-3xl text-[#f5f5f5] tracking-tight mb-3">
                  {c.title}
                </h3>
                <p className="text-base leading-relaxed text-[#a1a1aa] max-w-md">{c.body}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
